import React from 'react';

import { Row, Col, Card } from 'react-bootstrap';

import { Link } from 'react-router-dom';

/* Navigation cards linking to each admin management area. */
const CARDS = [
  {
    to: '/admin/products',
    icon: '📦',
    title: 'Product Management',
    desc: 'Add, Edit & Delete Products'
  },
  {
    to: '/admin/orders',
    icon: '📋',
    title: 'Order Management',
    desc: 'Update Order Status'
  },
  {
    to: '/admin/users',
    icon: '👥',
    title: 'User Management',
    desc: 'View & Manage Users'
  },
  {
    to: '/admin/categories',
    icon: '📂',
    title: 'Category Management',
    desc: 'Add, Edit & Delete Categories'
  },
  {
    to: '/admin/coupons',
    icon: '🎟️',
    title: 'Coupon Management',
    desc: 'Create & Manage Discount Coupons'
  },
  {
    to: '/admin/tickets',
    icon: '🎫',
    title: 'Support Tickets',
    desc: 'View & Manage Customer Support Requests'
  },
  {
    to: '/admin/refunds',
    icon: '💰',
    title: 'Refund Management',
    desc: 'View & Manage Customer Refund Requests'
  },
  {
    to: '/admin/reviews',
    icon: '⭐',
    title: 'Review Management',
    desc: 'See Product Ratings & Update Poorly Reviewed Products'
  },
  {
    to: '/admin/product-time',
    icon: '⏱',
    title: 'Engagement Time',
    desc: 'See How Long Customers Spend On Each Product'
  },
  {
    to: '/admin/delivery-partners',
    icon: '🛵',
    title: 'Delivery Partners',
    desc: 'Approve & Manage Your Delivery Fleet'
  }
];

function ManagementCards() {
  return (
    <Row className="g-4 justify-content-center">
      {CARDS.map((c) => (
        <Col xs={6} lg={3} md={6} className="mb-4" key={c.to}>
          <Card
            as={Link}
            to={c.to}
            className="shadow-lg border-0 text-center p-4 text-decoration-none h-100 mgmt-card"
            style={{
              borderRadius: '30px',
              color: '#000',
              minHeight: '420px',
              transition: '0.3s'
            }}
          >
            <Card.Body className="d-flex flex-column justify-content-center">
              <h1 style={{ fontSize: '4rem' }}>{c.icon}</h1>

              <h3
                className="fw-bold mt-3"
                style={{
                  minHeight: '80px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center'
                }}
              >
                {c.title}
              </h3>

              <p className="text-muted mt-2" style={{ fontSize: '1.1rem' }}>
                {c.desc}
              </p>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default ManagementCards;
